import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { GalleryItemType } from "~/components/Gallery/types";
import { ConfigurableTableCells } from "~/components/TableView/TableRow/ConfigurableTableCells";
import { boardTableRowInfo } from "~/components/TableView/utils";
import { SelectableTableRow } from "./SelectableTableRow";
function _BoardTableRow(param) {
    let { data, boardProps, CustomFieldTableCell, canSelect = false, renderNameCell, keyboardListenerProps } = param;
    const renderCustomFieldTableCellComponent = useCallback((option)=>/*#__PURE__*/ {
        var _option_customFieldId;
        return _jsx(CustomFieldTableCell, {
            customFieldId: (_option_customFieldId = option.customFieldId) !== null && _option_customFieldId !== void 0 ? _option_customFieldId : "",
            customFieldName: option.fieldName,
            board: data
        }, option.customFieldId);
    }, [
        CustomFieldTableCell,
        data
    ]);
    const contextMenuOptions = useMemo(()=>boardProps.getItemMenuOptions({
            trackLocation: "table-item-context-menu"
        }), [
        boardProps
    ]);
    const item = useMemo(()=>{
        /**
     * Had to declare the type explicitly here cause useMemo screws types up
     */ const item = {
            id: data.id,
            type: GalleryItemType.board,
            item: data
        };
        return item;
    }, [
        data
    ]);
    const renderCells = useCallback((param)=>{
        let { isSelected, isHovering } = param;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                renderNameCell({
                    isHovering,
                    isSelected
                }),
                /*#__PURE__*/ _jsx(ConfigurableTableCells, {
                    renderCustomFieldTableCellComponent: renderCustomFieldTableCellComponent,
                    rowInfo: boardTableRowInfo(data)
                })
            ]
        });
    }, [
        data,
        renderCustomFieldTableCellComponent,
        renderNameCell
    ]);
    const onRowClick = useCallback(()=>boardProps.onItemClick("table-cell"), [
        boardProps
    ]);
    return /*#__PURE__*/ _jsx(SelectableTableRow, {
        isSelectable: canSelect,
        item: item,
        onRowClick: onRowClick,
        getSelectionMenuOptions: boardProps.getSelectionMenuOptions,
        contextMenuOptions: contextMenuOptions,
        renderCells: renderCells,
        keyboardListenerProps: keyboardListenerProps
    });
}
export const BoardTableRow = /*#__PURE__*/ memo(_BoardTableRow);
